import React from 'react';
import { BookingPurchaseDialog } from './BookingPurchaseDialog';
import type { BookEventHostData } from './bookEvent.types';
import { useBookingPurchaseDialog } from './useBookingPurchaseDialog';

type Props = Readonly<{
  data: BookEventHostData;
}>;

export function BookEventDialog({ data }: Props) {
  const dialogData = useBookingPurchaseDialog(data);

  return <BookingPurchaseDialog data={dialogData} />;
}
